<template>
    <div class="container dashboard">
        <div class="row">
            <div class="col-lg-5 col-12 overflow-auto shadow">
                <div class="row"><h5 class="text-center head">{{ attention }}</h5></div>
                <div class="row"></div>
            </div>
            <div class="col-lg-1 col-0"></div>
            <div class="col-lg-5 col-12 overflow-auto shadow">
                <div class="row"><h5 class="text-center head">{{ orders }}</h5></div>
                <div class="row columns">
                    <div class="col-lg-4 col-6 truncate" :title=order_column_number>{{ order_column_number }}</div>
                    <div class="col-lg-2 col-1 truncate" :title=order_column_ordered>{{ order_column_ordered }}</div>
                    <div class="col-lg-2 col-1 truncate" :title=order_column_delivered>{{ order_column_delivered }}</div>
                    <div class="col-lg-4 col-4 truncate" :title=order_column_date>{{ order_column_date }}</div>
                </div>
                <div v-for="order in dataOrders" :key="order.subject" :class="['row', 'itemhover', { 'done': order.ordered_all === order.delivered_all }]" @click="toggleOrder(order.subject)">
                    <div class="row">
                        <div class="col-lg-4 col-6">{{ order.order_number }}</div>
                        <div class="col-lg-2 col-1">{{ order.ordered_all }}</div>
                        <div class="col-lg-2 col-1">{{ order.delivered_all }}</div>
                        <div class="col-lg-4 col-4">{{ order.date }}</div>
                    </div>
                    <div v-if="isOrderOpen(order.subject)">
                        <div v-for="(item, listNumber) in order.items" :key="listNumber" class="row itemhover">
                            <div class="col-lg-1 col-1"></div>
                            <div :title="item.name" class="col-lg-6 col-6 truncate">{{ item.name }}</div>
                            <div class="col-lg-2 col-2">{{ item.ordered }}</div>
                            <div class="col-lg-2 col-2">{{ item.delivered }}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-lg-5 col-12 overflow-auto shadow">
                <div class="row"><h5 class="text-center head">{{ receipts }}</h5></div>
                <div class="row columns">
                    <div class="col-lg-5 col-6 truncate" :title=order_column_receiptnumber>{{ order_column_receiptnumber }}</div>
                    <div class="col-lg-2 col-2 truncate" :title=order_column_delivered>{{ order_column_delivered }}</div>
                    <div class="col-lg-5 col-4 truncate" :title=order_column_date>{{ order_column_date }}</div>
                </div>
                <div v-for="item in dataReceipt" :key="item.subject" class="row itemhover">
                    <div class="col-lg-5 col-6">{{ item.order_number }}</div>
                    <div class="col-lg-2 col-2">{{ item.ordered_all }}</div>
                    <div class="col-lg-5 col-4">{{ item.date }}</div>
                </div>
            </div>
            <div class="col-lg-1 col-0"></div>
            <div class="col-lg-5 col-12 overflow-auto shadow">
                <div class="row"><h5 class="text-center head">{{ deliveryNote }}</h5></div>
                <div class="row columns">
                    <div class="col-lg-10 col-8 truncate" :title=order_column_productname>{{ order_column_productname }}</div>
                    <div class="col-lg-2 col-4 truncate" :title=order_column_quantity>{{ order_column_quantity }}</div>
                </div>
                <div v-for="item in dataDeliveryNotes" :key="item.name" class="row itemhover">
                    <div :title="item.name" class="col-lg-10 col-8 truncate">{{ item.code }}</div>
                    <div class="col-lg-2 col-4">{{ item.stock }}</div>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-lg-5 col-12 overflow-auto shadow">
                <div class="row"><h5 class="text-center head">{{ deliveryNote }}</h5></div>
                <div class="row columns">
                    <div class="col-lg-8 col-8 truncate" :title=order_column_number>{{ order_column_number }}</div>
                    <div class="col-lg-4 col-4 truncate" :title=order_column_date>{{ order_column_date }}</div>
                </div>
                <div v-for="note in dataDeliveryNotes" :key="note.subject" class="row itemhover" @click="toggleNote(note.subject)">
                    <div class="row">
                        <div class="col-lg-6 col-6">{{ note.code }}</div>
                        <div class="col-lg-2 col-2">{{ note.quantity }}</div>
                        <div class="col-lg-4 col-4">{{ note.date }}</div>
                    </div>
                    <div v-if="isNoteOpen(note.subject)">
                        <div v-for="(item, listNumber) in note.items" :key="listNumber" class="row itemhover">
                            <div class="col-lg-1 col-1"></div>
                            <div :title="item.name" class="col-lg-9 col-9 truncate">{{ item.name }}</div>
                            <div class="col-lg-2 col-2">{{ item.quantity }}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default{
        name: 'DashboardPage',
        data(){
            return{
                toggledOrders: [],
                toggledNotes: []
            }
        },
        computed:{
            attention(){
                return this.$store.state.languageData.languageArray ? this.$store.state.languageData.languageArray.dash_attention : 'Need your attention';
            },
            orders(){
                return this.$store.state.languageData.languageArray ? this.$store.state.languageData.languageArray.dash_order : 'Your orders';
            },
            receipts(){
                return this.$store.state.languageData.languageArray ? this.$store.state.languageData.languageArray.dash_receiptgoods : 'Your receipt of goods';
            },
            stock(){
                return this.$store.state.languageData.languageArray ? this.$store.state.languageData.languageArray.dash_stockstatus : 'Your stock status';
            },
            deliveryNote(){
                return this.$store.state.languageData.languageArray ? this.$store.state.languageData.languageArray.dash_deliverynote : 'Your delivery notes';
            },
            dataReceipt(){
                return this.$store.state.dashboardData.receipts ? this.$store.state.dashboardData.receipts : 'Loading receipts...';
            },
            dataOrders(){
                return this.$store.state.dashboardData.orders ? this.$store.state.dashboardData.orders : 'Loading orders...';
            },
            dataStock(){
                return this.$store.state.dashboardData.ownStock ? this.$store.state.dashboardData.ownStock : 'Loading stock...';
            },
            dataDeliveryNotes(){
                return this.$store.state.dashboardData.deliveryNote ? this.$store.state.dashboardData.deliveryNote : 'Loading delivery notes...';
            },
            order_column_ordered(){
                return this.$store.state.languageData.languageArray ? this.$store.state.languageData.languageArray.order_column_ordered : 'Ordered quantity';
            },
            order_column_delivered(){
                return this.$store.state.languageData.languageArray ? this.$store.state.languageData.languageArray.order_column_delivered : 'Delivered quantity';
            },
            order_column_number(){
                return this.$store.state.languageData.languageArray ? this.$store.state.languageData.languageArray.order_column_number : 'Order number';
            },
            order_column_date(){
                return this.$store.state.languageData.languageArray ? this.$store.state.languageData.languageArray.order_column_date : 'Date';
            },
            order_column_productname(){
                return this.$store.state.languageData.languageArray ? this.$store.state.languageData.languageArray.order_column_productname : 'Product name';
            },
            order_column_quantity(){
                return this.$store.state.languageData.languageArray ? this.$store.state.languageData.languageArray.order_column_quantity : 'Quantity';
            },
            order_column_receiptnumber(){
                return this.$store.state.languageData.languageArray ? this.$store.state.languageData.languageArray.order_column_receiptnumber : 'Receipt number';
            }
        },
        methods:{
            getDashboardData(){
                this.$store.dispatch('loadDashboardData');
            },
            toggleOrder(subject){
                const index = this.toggledOrders.indexOf(subject);
                if(index === -1){
                    this.toggledOrders.push(subject);
                }else{
                    this.toggledOrders.splice(index, 1);
                }
            },
            isOrderOpen(subject){
                return this.toggledOrders.includes(subject);
            },
            toggleNote(subject){
                const index = this.toggledNotes.indexOf(subject);
                if(index === -1){
                    this.toggledNotes.push(subject);
                }else{
                    this.toggledNotes.splice(index, 1);
                }
            },
            isNoteOpen(subject){
                return this.toggledNotes.includes(subject);
            }
        },
        mounted(){
            this.$store.dispatch('loadDashboardData');
            setTimeout(() =>{
                console.log(this.$store.state.dashboardData);
            }, 500);
        }
    }
</script>

<style scoped>
.shadow{
    box-shadow: 0px 0px 10px #3838382c;
    min-height: 200px;
    max-height: 350px;
    margin-top: 5px;
    margin-bottom: 15px;
    padding-top: 5px;
    user-select: none;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-drag: none;
    -webkit-user-drag: none;
    cursor: default;
}
.itemhover:hover{
    background-color: #b2dfff;
}
.truncate {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.done{
    background-color: #80ed80;
}

.columns{
    border-bottom: 1px solid #000000a3;
}
</style>